// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__uzq21","root":"styles_root__YE60C"};